// src/utils/searchUtil.js
const SEARCH_HISTORY_KEY = 'search_history_list'
const SEARCH_HISTORY_MAX_LENGTH = 20

/**
 * 保存搜索历史
 * @param {string} keyword 搜索关键词
 */
export const saveSearchHistory = (keyword) => {
  if (!keyword || typeof keyword !== 'string' || keyword.trim() === '') return
  const trimKeyword = keyword.trim()

  let historyList = JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY) || '[]')
  // 去重（已存在则删除原有项）
  historyList = historyList.filter(item => item.trim() !== trimKeyword)
  // 新增到头部（最新在前）
  historyList.unshift(trimKeyword)
  // 限制最大条数
  if (historyList.length > SEARCH_HISTORY_MAX_LENGTH) {
    historyList = historyList.slice(0, SEARCH_HISTORY_MAX_LENGTH)
  }
  // 保存到本地存储
  localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(historyList))
  return historyList
}

/**
 * 获取搜索历史
 * @returns {Array} 历史关键词列表
 */
export const getSearchHistory = () => {
  try {
    return JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY) || '[]')
  } catch (e) {
    localStorage.removeItem(SEARCH_HISTORY_KEY)
    return []
  }
}

/**
 * 删除单条搜索历史
 * @param {string} keyword 要删除的关键词
 */
export const deleteSingleHistory = (keyword) => {
  if (!keyword || typeof keyword !== 'string') return []
  let historyList = JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY) || '[]')
  historyList = historyList.filter(item => item.trim() !== keyword.trim())
  localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(historyList))
  return historyList
}

/**
 * 清空所有搜索历史
 */
export const clearAllSearchHistory = () => {
  localStorage.removeItem(SEARCH_HISTORY_KEY)
  return []
}
